import { render, staticRenderFns } from "./AreaComponent.vue?vue&type=template&id=b43b6e96&"
import script from "./AreaComponent.vue?vue&type=script&lang=js&"
export * from "./AreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports